import AppForm from '../app-components/Form/AppForm';
import {normalizeFormValue} from '../utils.js';

Vue.component('employee-attendance-form', {
    mixins: [AppForm],
    props: {
        trans: { type: Object },
        quarters: { type: Array }
    },
    
    data: function() {
        return {
            mutableQuarters: this.quarters,
            activeQuarter: this.quarters[0],
            // server errors by quarter id, shown until the submitted value is changed
            serverErrors: {}
        };
    },

    methods: {
        correctBasicInputDecimals(vmodelName,$event)
        {
            // empty input stays null (= not imported), it must not turn into 0
            this.activeQuarter[vmodelName] = $event.target.value ? this.sanitizeDecimalPoint($event.target.value) : null;
        },
        
        sanitizeDecimalPoint(val)
        {
            val = ""+val;
            return (val ? val.replace(",",".") : val);
        },
        
        selectQuarter: function(item)
        {
            this.activeQuarter = item;
        },
        
        getData: function()
        {
            return this.mutableQuarters;
        },

        // errors: [{quarter: <copy of the submitted quarter>, msg: '...'}]
        setServerErrors(errors)
        {
            this.clearServerErrors();
            errors.forEach(error => {
                this.$set(this.serverErrors, error.quarter.id, {msg: error.msg, value: normalizeFormValue(error.quarter.avgHourSalary)});
            });

            if (errors.length > 0 && !this.quarterServerError(this.activeQuarter)) {
                this.selectQuarter(this.mutableQuarters.find(quarter => quarter.id === errors[0].quarter.id) || this.activeQuarter);
            }
        },

        clearServerErrors()
        {
            this.serverErrors = {};
        },

        quarterServerError(quarter)
        {
            const error = quarter && this.serverErrors[quarter.id];
            return error && error.value === normalizeFormValue(quarter.avgHourSalary) ? error.msg : null;
        },

        avgHourSalaryError()
        {
            return this.errors.first('avg_hour_salary') || this.quarterServerError(this.activeQuarter);
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/employee/EmployeeAttendanceForm.js